import { PageHero } from "@/components/sections/PageHero";
import { CTABand } from "@/components/sections/CTABand";
import { INDUSTRIES, IMAGES } from "@/lib/site";

const details = {
  "General Contractors": "Coordinated shop schedules, structural steel capacity, and submittal support so your coating step never delays the build.",
  "Metal Fabricators": "Recurring PO programs, JIT scheduling, and bonded inventory of your standard colors — one coater for every job you push out.",
  "Architects & Designers": "AAMA-class architectural finishes, warranty-backed colors, and finish samples for specification packages.",
  "Structural Engineers": "Documented surface preparation and coating chemistry matched to the corrosion, UV, and service life your design demands.",
  "OEM Manufacturers": "Production-tempo output with QC gates traceable to your PO. Weekly and monthly release schedules supported.",
  "Government Contractors": "Documented processes and finish specifications for federal, state, and municipal contract deliverables.",
  "Aerospace & Defense": "Precision masking, controlled substrates, and lot-level traceability for aerospace and defense subcontract work.",
  "Automotive & Restoration": "Full frame and suspension capacity, high-temp coatings, and one QC standard across every batch.",
  "Signage & Displays": "Uniform color across multi-site rollouts, batch and rack processing for fixtures and frames.",
  "Agriculture & Heavy Equipment": "Long implements, heavy weldments, and corrosion-resistant chemistries for real-world field environments.",
  "Energy & Utilities": "Structural steel, enclosures, and mounting hardware finished to the durability spec your service life requires.",
  "Purchasing & Procurement": "One vendor, one point of contact, one PO — from prep through packaging and freight.",
};

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHero
        eyebrow="Industries Served"
        title={<>Twelve industries. <span className="text-[#FF5722]">One</span> coating partner.</>}
        subtitle="Our facility is engineered to serve the demanding industrial customers of the Southeast — from OEM programs to one-off government contract work."
        image={IMAGES.warehouse}
      />

      <section className="section px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {INDUSTRIES.map((i, idx) => (
            <div key={i} className="border border-white/10 p-8 hover:border-[#FF5722] transition-colors" data-testid={`industry-${idx}`}>
              <div className="text-[#FF5722] font-display text-xl">{String(idx + 1).padStart(2, "0")}</div>
              <div className="font-display text-2xl md:text-3xl tracking-tight mt-3">{i}</div>
              <p className="text-zinc-400 text-sm mt-4 leading-relaxed">{details[i]}</p>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
